import React, { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { useSelector } from "react-redux";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import { resetVw_Samithi_MembersToInit, setVw_Samithi_MembersMessage } from "redux/actions";
import { Button, Card, Col, Form, InputGroup } from "react-bootstrap";
import { Constant } from "template/Constant";
type Props = {
    hideShowForm: (action) => void;
    handleRowEdit: (row) => void;
    getData: (page, pageSize, searchKey) => void;
};
export const Vw_Samithi_MembersTable: React.FC<Props> = ({ hideShowForm, handleRowEdit, getData }) => {
    const dispatch = useAppDispatch();
    const [search, setSearch] = useState('');
    const [rowData, setRowData] = useState(undefined);
    const rData = useSelector((state: RootState) => state.vw_samithi_members);
    const handleSearch = () => {
        if (search.length > 0) {
            getData(Constant.defaultPageNumber, Constant.defaultPageSize, search);
        }
    }
    const handlePerRowsChange = async (newPerPage, page) => {
        await getData(page, newPerPage, '');
    }
    const handlePageChange = (page) => {
        getData(page, rData.pageSize, '');
    };
    useEffect(() => {
        if (rData && rData.list && rData.list.length === 0) {
            dispatch(resetVw_Samithi_MembersToInit());
            getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
        }
    },[rData.list.length])
    const handleReset = () => {
        setSearch('');
        dispatch(resetVw_Samithi_MembersToInit());
        getData(Constant.defaultPageNumber, rData.pageSize, '');
    }

    const handleRowSelection = (row) => {
        console.log(row); // Row Selection Functionality can be written here
    }
    const handleAddButtonClick = () => {
        dispatch(setVw_Samithi_MembersMessage(''));
        hideShowForm('add');
    }

    const columns = [
        {name: 'samithi_member_id', selector: row => row.samithi_member_id, sortable: true},
{name: 'name', selector: row => row.name, sortable: true},
{name: 'surname', selector: row => row.surname, sortable: true},
{name: 'father_name', selector: row => row.father_name, sortable: true},
{name: 'rev_addrs1', selector: row => row.rev_addrs1, sortable: true},
{name: 'rev_addrs2', selector: row => row.rev_addrs2, sortable: true},
{name: 'rev_addrs3', selector: row => row.rev_addrs3, sortable: true},
{name: 'rev_village', selector: row => row.rev_village, sortable: true},
{name: 'rev_mandal', selector: row => row.rev_mandal, sortable: true},
{name: 'pincode', selector: row => row.pincode, sortable: true},
{name: 'vibhag_id', selector: row => row.vibhag_id, sortable: true},
{name: 'vibhag_name', selector: row => row.vibhag_name, sortable: true},
{name: 'zilla_id', selector: row => row.zilla_id, sortable: true},
{name: 'zilla_name', selector: row => row.zilla_name, sortable: true},
{name: 'nagar_khanda_id', selector: row => row.nagar_khanda_id, sortable: true},
{name: 'nagar_khanda_name', selector: row => row.nagar_khanda_name, sortable: true},
{name: 'upamandal_id', selector: row => row.upamandal_id, sortable: true},
{name: 'upamandal_name', selector: row => row.upamandal_name, sortable: true},
{name: 'is_basti_gramam', selector: row => row.is_basti_gramam, sortable: true},
{name: 'basti_gramam_id', selector: row => row.basti_gramam_id, sortable: true},
{name: 'basti_name', selector: row => row.basti_name, sortable: true},
{name: 'status', selector: row => row.status, sortable: true},
{name: 'created_on', selector: row => row.created_on, sortable: true},
{name: 'created_by', selector: row => row.created_by, sortable: true},
{name: 'modified_on', selector: row => row.modified_on, sortable: true},
{name: 'modified_by', selector: row => row.modified_by, sortable: true},

    ];
    return (
        <Card className="shadow mb-4">
            <Card.Header className="py-3">
                <h6 className="m-0 font-weight-bold text-primary">Vw_Samithi_Members List ({rData.totalCount})
                    <Button variant="light" className="btn-circle btn-sm ml-2" onClick={handleReset}><i className="fa fa-refresh"></i></Button>
                    <Button className="btn-icon-split float-right" onClick={handleAddButtonClick}>
                        <span className="icon text-white-50">
                            <i className="fas fa-add"></i>
                        </span>
                        <span className="text">Add New</span>
                    </Button></h6>

            </Card.Header>
            <Card.Body>
                <Col className="ml-auto" md={3} xs={12} xl={3}>
                    <InputGroup>
                        <Form.Control
                            placeholder="Search"
                            aria-label="Search"
                            aria-describedby="basic-search"
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <Button disabled={search.length <= 2} variant="dark" className="rounded-0 rounded-right" id="button-search" onClick={handleSearch}>
                            Search
                        </Button>
                    </InputGroup>
                </Col>
                <div className="table-responsive">
                    <DataTable
                        selectableRows={true}
                        onSelectedRowsChange={handleRowSelection}
                        paginationPerPage={Constant.defaultPageNumber}
                        paginationRowsPerPageOptions={Constant.paginationRowsPerPageOptions}
                        columns={columns} data={rData.list}
                        onChangeRowsPerPage={handlePerRowsChange}
                        paginationTotalRows={rData.totalCount}
                        className="table table-bordered"
                        pagination
                        paginationServer
                        onChangePage={handlePageChange}></DataTable>
                </div>
            </Card.Body>
               </Card>
    );
}

